import { CdkMenuModule } from '@angular/cdk/menu';
import { NgModule } from '@angular/core';

import { ReachSmallMenuComponent } from './menu.component';

const menus = [CdkMenuModule, ReachSmallMenuComponent];

@NgModule({
	imports: menus,
	exports: menus,
})
export class MenusModule {}
